export { default } from "./BoxRatio-component";
